import type { CameraTarget } from './camera-follow';

export const BLACKBIRD_TILT = 45;
export const BLACKBIRD_ALTITUDE = 650;
export const BLACKBIRD_LENS = 50;

/** Stable tracking at a local map scale; lens choices retain their existing offsets. */
export function blackbirdTrackingPose<T extends CameraTarget>(bearing: number, centerAt: (zoom: number) => T,
  distanceOffset: number, viewportOffset: number) {
  const zoom = 16 + distanceOffset + viewportOffset;
  return { bearing, center: centerAt(zoom), pitch: BLACKBIRD_TILT, zoom };
}
